/**
 *
 * @param str
 * @returns
 *
 * It's better to all remove zero-width characters and replace others invisible characters to a space.
 * But the list of them is too large. So I just handle the &nbsp here to fix an occurred UI problem.
 *
 * @see https://github.com/hediet/vscode-unicode-data/blob/256cd87d2f6822629e552f7af12f86393bb3a38c/out/invisibleCharacters-formatted.json
 */
export const normalizeString = (str: string) => str.replace(/\xa0/g, ' ')

/**
 * Convert full width character to half width form.
 * @see https://stackoverflow.com/a/20488304/7511849
 *
 * @param str
 * @returns
 */
export const toHalfWidth = (str: string) =>
  str.replace(/[\uff01-\uff5e]/g, function (ch) {
    return String.fromCharCode(ch.charCodeAt(0) - 0xfee0)
  })

/**
 * Replace brackets and some special character to space for suit whitespace segmentation.
 *
 * @param str
 * @returns
 */
export const normalizeSearch = (str: string) =>
  toHalfWidth(str)
    .split(/[{}[\]()/\\,.?!]/)
    .map(i => i.trim())
    .filter(i => i)
    .join(' ')

/**
 * Convert a string to title-cased string.
 */
export const toTitleCase = (str: string) => {
  return str
    .split(/[\s_]+/)
    .map(i => i[0].toUpperCase() + i.slice(1))
    .join(' ')
}

/**
 * Tests ASCII chars alongside with punctuations
 * Enables unicode-aware mode
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape
 */
// eslint-disable-next-line no-control-regex
const RE_ASCII_CHAR_WITH_PUNCTUATIONS = /^[\x00-\x7F]|\p{P}$/u

/**
 * Puncutuation characters won't be counted as non-ASCII
 */
export function getNonAsciiStats(str: string) {
  // Array.from handles most multi-byte chars; Intl.Segmenter is more
  // accurate for complex grapheme clusters (e.g. emoji ZWJ sequences).
  const graphemes = Intl.Segmenter
    ? [
        ...new Intl.Segmenter('en', { granularity: 'grapheme' }).segment(str),
      ].map(g => g.segment)
    : Array.from(str)
  const total = graphemes.length
  const nonAscii = graphemes.filter(
    g => !RE_ASCII_CHAR_WITH_PUNCTUATIONS.test(g),
  ).length

  return {
    totalCount: total,
    nonAsciiCount: nonAscii,
    nonAsciiRatio: nonAscii / total,
  }
}
